import React, { PureComponent } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import DynamicInput from './InputBuild.component'

export class StartFormComponent extends PureComponent {
  componentDidMount() {
    const { onStartForm } = this.props

    onStartForm && onStartForm(new Date())
  }

  render() {
    const {
      questionsGroups,
      questionsValue,
      onChange,
      classes,
      form,
    } = this.props

    return (
      <Grid container spacing={2}>
        {questionsGroups.map(questionGroup => (
          <Grid item xs={12} key={questionGroup._id}>
            <Paper className={classes.paperBase}>
              <Typography gutterBottom variant='h5'>
                {questionGroup.name}
              </Typography>
              <br />
              {questionGroup.questions.map(question => (
                <DynamicInput
                  key={question._id}
                  inputtype={question.type}
                  className={classes.inputs}
                  id={question._id}
                  label={question.label}
                  value={(questionsValue[question._id] || {}).value}
                  onChange={(event, option) => onChange({
                    form,
                    question_id: question._id,
                    questionGroupId: questionGroup._id,
                    ...(option
                      ? {
                        abstractQuestionGroupId: option.question_group_id,
                        value: option.value,
                        finalize: option.finalize,
                        stage_id: option.stage_id,
                      }
                      : { value: event.target.value }
                    ),
                  })}
                  margin='normal'
                  options={question.options}
                  error={(questionsValue[question._id] || {}).error}
                />
              ))}
            </Paper>
          </Grid>
        ))}
      </Grid>
    )
  }
}

const useStyles = () => ({
  root: {
    overflowY: 'auto',
    height: '100%',
  },
  paperBase: {
    boxSizing: 'border-box',
    padding: 25,
    marginBottom: 10,
  },
  inputs: {
    width: '100%',
  },
})

export default withStyles(useStyles)(StartFormComponent)
